import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../app/core/models/generic-models';
import * as complianceActions from '../actions/static-data-compliance.actions';
import { IStaticDataResponse } from '../models/static-data.model';

export const staticDataClientTypesFeatureKey = 'staticDataClientTypes';

export interface StaticDataClientTypesState {
  loading: boolean;
  data: IStaticDataResponse[];
  error: any;
}

export const initialState: StaticDataClientTypesState = {
  loading: false,
  data: [],
  error: null
};

export const reducer = createReducer(
  initialState,
  on(complianceActions.loadClientTypes, state => ({ ...state, loading: true, error: null })),
  on(complianceActions.loadClientTypesSuccess, (state, { response }) => ({ ...state, loading: false, data: response, error: null })),
  on(complianceActions.loadClientTypesFailure, (state, { error }) => ({ ...state, loading: false, error }))
);

export const getClientTypes = (state: StaticDataClientTypesState) => state.data;
export const getClientTypesLoading = (state: StaticDataClientTypesState) => state.loading;
export const getClientTypesError = (state: StaticDataClientTypesState) => state.error;